import { ClientShortHandName } from "@snoam/mono-scc";
import { Identity, IIdentityOptions } from "@schibsted/account-sdk-browser";
import spidOptions from "./spidOptions";
import { isProduction } from "../fastflowUtils";

function getIdentity(
  clientShortHandName: ClientShortHandName | ''
): Identity {
  const spidOpts: IIdentityOptions = spidOptions(
    clientShortHandName,
    isProduction()
  );
  const identity = new Identity(spidOpts);
  (identity as any)._enableSessionCaching = false;
  (window as any).identity = identity;
  return identity;
}

export default getIdentity;
